<template>
  <div>
    <h1 class="ma-2">
      สร้างบริการคอร์ส
    </h1>
    <v-container>
      <course-form
        :services="services"
        :form-data="formData"
        @submit="editCourse"
      />
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';
import CourseForm from '@/components/CourseForm.vue';
import http from '@/http';

export default {
  name: 'CourseEditView',
  components: {
    CourseForm,
  },
  data() {
    return {
      services: [],
      formData: {},
    };
  },
  async created() {
    const services = await http.get('/services?status=ACTIVE');
    this.services = [...services.data];
    const formData = await http.get(`/courses/${this.$route.params.id}`);
    this.formData = { ...formData.data };
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    async editCourse(formData) {
      const data = new FormData();
      Object.keys(formData).forEach(key => data.append(key, formData[key]));
      await http.put(`/courses/${this.$route.params.id}`, data);
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('แก้ไขบริการคอร์สแล้ว');
      this.$router.push('/admin/courses');
    },
  },
};
</script>
